import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./auth.service";
// import { AuthenticationService } from '../_services';
export class AuthGuard {
    constructor(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    canLoad(route) {
        console.log('window.location.pathname', window.location.pathname);
        if (this.authService.isAuthenticated()) {
            return true;
        }
        this.router.navigate(['/auth'], { queryParams: { returnUrl: window.location.pathname } });
        return false;
    }
    canActivate(route, state) {
        if (this.authService.isAuthenticated()) {
            return true;
        }
        this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
        return false;
    }
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
}
AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService)); }, token: AuthGuard, providedIn: "root" });
